import { render, staticRenderFns } from "./bgGmap.vue?vue&type=template&id=2a3a8fec&"
import script from "./bgGmap.vue?vue&type=script&lang=js&"
export * from "./bgGmap.vue?vue&type=script&lang=js&"
import style0 from "./bgGmap.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports